import { jsx as _jsx } from "react/jsx-runtime";
import { useControlled } from "./controlled";
import { useMemo } from "react";
import { Platform, View } from "react-native";
import NativeMenu from "./specs/OneNativeMenuNativeComponent";
import { flattenMenuItems } from "./menuItems";
import { assertSwiftUIValue } from "./generated/swiftui";
function Menu(props) {
  return /* @__PURE__ */ _jsx(MenuPresentation, {
    ...props,
    presentation: "menu"
  });
}
function ContextMenu(props) {
  var _props_accessibilityLabel;
  return /* @__PURE__ */ _jsx(MenuPresentation, {
    ...props,
    accessibilityLabel: (_props_accessibilityLabel = props.accessibilityLabel) !== null && _props_accessibilityLabel !== void 0 ? _props_accessibilityLabel : "",
    presentation: "contextMenu"
  });
}
function MenuPresentation(param) {
  var { items, onAction, primaryAction, children, onValueChange, onPickerChange, revision = 0, menuOrder = "automatic", menuActionDismissBehavior = "automatic", disabled = false, accessibilityLabel, presentation, ...props } = param;
  var iosVersion = Number.parseFloat(String(Platform.Version));
  assertSwiftUIValue("MenuOrder", menuOrder, iosVersion);
  assertSwiftUIValue("MenuActionDismissBehavior", menuActionDismissBehavior, iosVersion);
  var nativeItems = useMemo(function() {
    return flattenMenuItems(items, iosVersion);
  }, [
    items,
    iosVersion
  ]);
  if (!onValueChange && nativeItems.some(function(item) {
    return item.type === "toggle";
  })) {
    var name = presentation === "contextMenu" ? "ContextMenu" : "Menu";
    throw new Error(`Swift.${name} with toggles requires onValueChange`);
  }
  if (!onPickerChange && nativeItems.some(function(item) {
    return item.type === "picker";
  })) {
    throw new Error("Swift.Menu with a Picker requires onPickerChange");
  }
  var controlled = useControlled(function(event) {
    return onValueChange === null || onValueChange === void 0 ? void 0 : onValueChange(event.id, event.value, event.sourceIndex);
  }, revision);
  var pickerControlled = useControlled(function(event) {
    return onPickerChange === null || onPickerChange === void 0 ? void 0 : onPickerChange(event.id, event.value);
  }, revision);
  return /* @__PURE__ */ _jsx(NativeMenu, {
    ...props,
    items: nativeItems,
    revision,
    acknowledgedEvent: controlled.acknowledgedEvent,
    pickerAcknowledgedEvent: pickerControlled.acknowledgedEvent,
    menuOrder,
    menuActionDismissBehavior,
    triggerLabel: accessibilityLabel,
    disabled,
    hasPrimaryAction: presentation === "menu" && !!primaryAction,
    presentation,
    onNativeMenuAction: function onNativeMenuAction(param2) {
      var { nativeEvent } = param2;
      return onAction(nativeEvent.id);
    },
    onNativeMenuPrimaryAction: function onNativeMenuPrimaryAction() {
      return primaryAction === null || primaryAction === void 0 ? void 0 : primaryAction();
    },
    onNativeMenuValueChange: function onNativeMenuValueChange(param2) {
      var { nativeEvent } = param2;
      return controlled.onNativeChange(nativeEvent);
    },
    onNativeMenuPickerChange: function onNativeMenuPickerChange(param2) {
      var { nativeEvent } = param2;
      return pickerControlled.onNativeChange(nativeEvent);
    },
    children: /* @__PURE__ */ _jsx(View, {
      collapsable: false,
      children
    })
  });
}
export {
  ContextMenu,
  Menu
};
//# sourceMappingURL=Menu.native.js.map
